module.exports = __webpack_public_path__ + "static/media/aditya_HTaVSc1Z6.fedaa91d.jpeg";